<div class="modal-header px-3 mt-2">
    <h4 class="modal-title" id="modal-basic-title">{{fromParent.isEdit ? 'Edit' : 'Create'}} Schedule</h4>
    <div>
        <!-- <a (click)="showCronList()" ngbTooltip="View Sample Cron Expressions" placement="left">
            <small>Help</small>
            <img src="/assets/images/icons/help.gif" width="25px" alt="" />
        </a> -->
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>


<div class="common-section modal-body ">
    <form [formGroup]="newScheduleForm" class="schedule-form " (ngSubmit)="onSubmit()">
        <div class="row form-group mt-2 mb-2 col-12">
            <div class="col-md-4">
                <label for=""> Name <span class="text-danger">*</span> </label>
                <input type="text" class="form-control form-control-sm" formControlName="name"
                    placeholder="Enter name" />
            </div>
            <div class="col-md-2 remove-padding-left">
                <label for=""> Start date & time (UTC) <span class="text-danger">*</span> </label>
                <input class="form-control form-control-sm" type="text" ngbDatepicker #d="ngbDatepicker"
                    (click)="d.toggle()" placeholder="dd-mm-yyyy" formControlName="beginDate"
                    [minDate]="fromParent.minDate" />
                <span *ngIf="scheduleDate.errors && scheduleDate.errors.ngbDate?.requiredBefore"
                    class="error-msg">Selected Date is before Today's date !</span>
            </div>
            <div class="col-md-2 remove-padding-left timestamp-display">
                <ngb-timepicker [meridian]="true" [size]="'small'" [seconds]="false"
                    formControlName="time"></ngb-timepicker>
            </div>
            <div class="col-md-4">
                <div class="d-flex justify-content-between">
                    <label for=""> Cron <span class="text-danger">*</span> </label>
                    <!-- <a (click)="showCronList()" ngbTooltip="View Sample Cron Expressions" placement="left">
                        <img src="/assets/images/icons/help.gif" width="22px" alt="" />
                    </a> -->
                </div>
                <input type="text" class="form-control form-control-sm" formControlName="cron"
                    placeholder="Ex: * * * ? * * (Every second)" />
                <p class="text-right text-info"><a (click)="showCronList()">View Sample Cron Expressions</a></p>
            </div>
        </div>

        <div class="row form-group col-12 pb-3">
            <div class="col-md-3"
                *ngIf="fromParent.moduleType === 'ENDPOINT' && fromParent.moduleDetails?.environmentSpecific">
                <label for=""> Environment <span class="text-danger">*</span> </label>
                <ng-select class="custom-style" id="environment" [items]="fromParent.child.activeEnv" bindLabel="name"
                    [clearable]="false" formControlName="environment" placeholder="Select Env" required></ng-select>
            </div>

            <div class="col-md-3" *ngIf="fromParent.moduleDetails.showBrowserOptions">
                <label for="">OS</label>
                <ng-select class="custom-style" id="os" [items]="fromParent.child.OsTypes" [clearable]="false"
                    formControlName="os"></ng-select>
            </div>

            <div class="col-md-3" *ngIf="fromParent.moduleDetails.showBrowserOptions">
                <label for="">Browser</label>
                <ng-select class="custom-style" id="browserType" [items]="fromParent.child.browserTypes"
                    [clearable]="false" formControlName="browserType"></ng-select>
            </div>
            <div class="col-md-3" *ngIf="fromParent.moduleType !== 'ENDPOINT'">
                <label>Environment Mapper</label>
                <ng-select class="custom-style" [items]="fromParent.child.activeEnv" bindLabel="name"
                    formControlName="environmentMap" placeholder="Select Environment"></ng-select>
            </div>
            <div class="col-md-1">
                <label for="" style="display: block">Active</label>
                <ui-switch size="small" [formControl]="newScheduleForm.controls['active']" checkedLabel="Yes"
                    uncheckedLabel="No"></ui-switch>
            </div>

            <div class="col-md-2">
                <label for="" style="display: block">
                    Disable On Failure
                    <i class="fas fa-info-circle" placement="top"
                        ngbTooltip="Schedule will be disabled when execution fails or skipped"></i>
                </label>
                <ui-switch size="small" [formControl]="newScheduleForm.controls['disableOnFailure']" checkedLabel="Yes"
                    uncheckedLabel="No"></ui-switch>
            </div>
        </div>


        <hr />
        <div class="row buttons">
            <div class="col-md-12 text-right">
                <button type="submit" class="btn relay-btn relay-createbtn"
                    [ngClass]="fromParent.isEdit?'update':'create'"
                    [disabled]="newScheduleForm.invalid">{{fromParent.isEdit?'Update':'Create'}}</button>
                <button type="button" class="btn relay-btn cancel" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </form>
</div>